import React from 'react'
import Rows from './Rows'

export default (props) => (
  <Rows baseName='monthlySavings' {...props} />
)
